module.exports = __webpack_public_path__ + "static/media/icon-contracts.7a51d88c.svg";